var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('blockquote',[_vm._l((_vm.content),function(cont,i){return [(cont.type === 'paragraph')?_c('Paragraph',{key:("list-paragraph-" + i),attrs:{"content":cont.content}}):_vm._e()]})],2)])}
var staticRenderFns = []

export { render, staticRenderFns }